module.exports = __webpack_public_path__ + "img/left_menu.fcea500.webp";